import { AddInsightToCollectionsButton, CreateInsightDataFn, Proposition } from '@ecosystem/newron-client-collections';
import { getCollectionsAmplitudeTrackingTags } from '@utils/collectionUtils/CollectionUtils';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { CollectionInsightType } from '@components/collections/Model';
import { RetailerOverviewCombinedChartInsight } from '@components/collections/retailer-overview-combined-chart/Model';
import * as styles from './RetailerOverviewCollectionButton.module.scss';
import classnames from 'classnames';
import { RetailerOverviewLineChartInsight } from '@components/collections/retailer-overview-line-chart/Model';
import { CreateViewStateFn } from '@ecosystem/newron-client-lib';

export interface RetailerOverViewCollectionButtonProps {
  createInsightDataFn: CreateInsightDataFn<RetailerOverviewCombinedChartInsight | RetailerOverviewLineChartInsight>;
  isDisabled: boolean;
  collectionInsightType: CollectionInsightType;
  createViewStateFn?: CreateViewStateFn<any>;
}

const RetailerOverviewCollectionButton: React.FC<RetailerOverViewCollectionButtonProps> = ({
  createInsightDataFn,
  isDisabled,
  collectionInsightType,
  createViewStateFn,
}) => {
  const pagesConfig = usePageConfig();

  return (
    <div
      className={classnames([
        {
          [styles.RetailerOverviewCollectionButton]: !isDisabled,
          [styles.RetailerOverviewCollectionButtonDisabled]: isDisabled,
        },
      ])}
    >
      <AddInsightToCollectionsButton<RetailerOverviewCombinedChartInsight | RetailerOverviewLineChartInsight>
        type={collectionInsightType}
        proposition={Proposition.Retail}
        createInsightDataFn={createInsightDataFn}
        selectDataType={true}
        defaultDataType={'live'}
        getTrackingTags={getCollectionsAmplitudeTrackingTags(pagesConfig)}
        createViewStateFn={createViewStateFn}
      />
    </div>
  );
};

export default RetailerOverviewCollectionButton;
